export const LookbackPeriodUnits = Object.freeze({
  months: "months",
  days: "days"
});
